import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Bell, ChevronLeft, Sparkles } from "lucide-react";
import { fmtDate } from "@/lib/format-date";
import { listAnnouncementsAll } from "@/lib/yatra-db";
import { useI18n, pickName } from "@/lib/i18n";

type A = {
  id: string;
  title_en: string;
  title_hi: string;
  title_gu: string;
  body_en: string;
  body_hi: string;
  body_gu: string;
  active: boolean;
  created_at: string;
};

export const Route = createFileRoute("/app/announcements")({ component: Announcements });

function Announcements() {
  const { t, lang } = useI18n();
  const [list, setList] = useState<A[]>([]);

  useEffect(() => {
    (async () => {
      setList(listAnnouncementsAll() as A[]);
    })();
  }, []);

  return (
    <div>
      <div
        className="relative px-5 pt-14 pb-5 text-primary-foreground"
        style={{ background: "var(--gradient-saffron)" }}
      >
        <Link
          to="/app"
          className="absolute left-4 top-14 inline-flex items-center gap-1 rounded-full glass px-3 py-1.5 text-xs font-semibold text-foreground shadow-sm"
        >
          <ChevronLeft className="h-3.5 w-3.5" /> {t("home")}
        </Link>
        <div className="flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-widest opacity-95">
          <Sparkles className="h-3 w-3" /> Live
        </div>
        <h1 className="mt-1 text-center font-serif text-2xl font-bold">Announcements</h1>
        <p className="text-center text-[11px] opacity-90">
          {list.filter((a) => a.active).length} live · {list.length} total
        </p>
      </div>

      <div className="space-y-3 px-5 pt-4">
        {list.length === 0 && (
          <div className="rounded-2xl border border-border bg-card p-6 text-center text-sm text-muted-foreground">
            No announcements yet
          </div>
        )}
        {list.map((a) => (
          <div key={a.id} className="rounded-2xl border border-border bg-card p-4">
            <div className="flex items-center justify-between">
              <span
                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold ${a.active ? "bg-green-100 text-green-700" : "bg-muted text-muted-foreground"}`}
              >
                <Bell className="h-3 w-3" /> {a.active ? "Live" : "Past"}
              </span>
              <span className="text-[10px] text-muted-foreground">{fmtDate(a.created_at)}</span>
            </div>
            <div className="mt-2 font-serif text-base font-bold leading-tight">
              {pickName(
                { name_en: a.title_en, name_hi: a.title_hi, name_gu: a.title_gu } as any,
                lang,
              )}
            </div>
            <p className="mt-1 text-xs text-muted-foreground">
              {pickName(
                { name_en: a.body_en, name_hi: a.body_hi, name_gu: a.body_gu } as any,
                lang,
              )}
            </p>
          </div>
        ))}
        <div className="h-6" />
      </div>
    </div>
  );
}
